import React from 'react'
import { Table, Column } from 'react-virtualized'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { fromNullable } from 'data.maybe'
import { pctFormatter, format } from '../utils'

import { getUnitMap } from 'analytics/selectors'

import styles from './event-table.css'

import R from 'ramda'

const ColHeader = styled.div`
  text-align: center;
`
const eventNumHeader = () => (
  <ColHeader>
    Event
    <br />
    Num
  </ColHeader>
)
const eventTypeHeader = () => (
  <ColHeader>
    Event
    <br />
    Type
  </ColHeader>
)
const avialCapHeader = () => (
  <ColHeader>
    Avail
    <br />
    Cap
  </ColHeader>
)
const fleetContribHeader = () => (
  <ColHeader>
    % Contrib.
    <br />
    To Fleet
  </ColHeader>
)
const detailContribData = ({ rowData: { detailContrib } }) =>
  `${format(detailContrib, pctFormatter)}`

const getSelectedIndex = (selected, events) =>
  fromNullable(selected)
    .map(sel =>
      R.findIndex(
        ({ unitId, year, eventNum }) =>
          sel.unitId === unitId && sel.year === year && sel.eventNum === eventNum,
        events
      )
    )
    .getOrElse(undefined)

export class EventContribTable extends React.Component {
  constructor(props) {
    super(props)

    const { events, selected } = props

    this.clearScroll = this.clearScroll.bind(this)
    // this.configureScroll(selected, events)
    const selectedIndex = getSelectedIndex(selected, events)

    this.state = {
      selectedIndex,
      scrollToIndex: selectedIndex,
    }
  }

  clearScroll() {
    setTimeout(() => {
      this.setState({
        scrollToIndex: undefined,
      })
    }, 500)
  }

  componentDidMount() {
    if (this.state.selected) this.clearScroll()
  }

  componentWillReceiveProps({ selected, events }) {
    // if (selected !== this.props.selected || events !== this.props.events)
    // {
    // }
    const selectedIndex = getSelectedIndex(selected, events)

    this.state = {
      selectedIndex,
      scrollToIndex: selectedIndex,
    }

    this.clearScroll()
  }

  render() {
    const { width, height, events, unitMap, showDetailContrib, detailContribEntity } = this.props

    const { selectedIndex, scrollToIndex } = this.state

    const unitData = ({ rowData: { unitId } }) => fromNullable(unitMap[unitId]).getOrElse(unitId)

    const contribData = ({ rowData: { value } }) => `${format(value, pctFormatter)}`

    const causeData = ({ rowData: { causeCode, description } }) => `${causeCode} - ${description}`
    const rowClass = ({ index }) =>
      index === -1 ? styles.headerRow : index === selectedIndex ? styles.selected : styles.row
    const detailContribHeader = () => (
      <ColHeader>
        % Contrib.
        <br />
        To {detailContribEntity}
      </ColHeader>
    )

    return (
      <Table
        width={width}
        height={height}
        headerHeight={70}
        rowHeight={25}
        rowCount={events.length}
        rowGetter={({ index }) => events[index]}
        rowClassName={rowClass}
        headerClassName={styles.header}
        scrollToIndex={scrollToIndex}
      >
        <Column
          label="Unit"
          dataKey="unitId"
          width={200}
          cellDataGetter={unitData}
          headerClassName={styles.headerCell}
        />
        <Column
          label="Year"
          dataKey="year"
          width={50}
          className={styles.valCell}
          headerClassName={styles.headerCell}
        />
        <Column
          label="Event Num"
          dataKey="eventNum"
          width={50}
          headerRenderer={eventNumHeader}
          className={styles.valCell}
        />
        <Column
          label="Event Type"
          dataKey="eventType"
          width={50}
          headerRenderer={eventTypeHeader}
          className={styles.valCell}
        />
        <Column
          label="Event Start"
          dataKey="eventStart"
          width={150}
          className={styles.valCell}
          headerClassName={styles.headerCell}
        />
        <Column
          label="Event End"
          dataKey="eventEnd"
          width={150}
          className={styles.valCell}
          headerClassName={styles.headerCell}
        />
        <Column
          label="Avail. Cap"
          dataKey="availCap"
          width={50}
          headerRenderer={avialCapHeader}
          className={styles.valCell}
        />
        <Column
          label="Contrib to Fleet"
          dataKey="value"
          width={89}
          className={styles.valCell}
          headerRenderer={fleetContribHeader}
          cellDataGetter={contribData}
        />
        {showDetailContrib ? (
          <Column
            label="Contrib to Unit"
            dataKey="unitEford"
            width={89}
            className={styles.valCell}
            headerRenderer={detailContribHeader}
            cellDataGetter={detailContribData}
          />
        ) : null}

        <Column
          label="Cause"
          dataKey="causeCode"
          width={200}
          flexGrow={1}
          flexShrink={0}
          cellDataGetter={causeData}
        />
      </Table>
    )
  }
}

const mapStateToProps = state => ({
  unitMap: getUnitMap(state),
})

const NoDataWrapper = props =>
  fromNullable(R.isEmpty(props.events) ? null : props.events)
    .map(e => <EventContribTable key={e} {...props} />)
    .getOrElse(null)

export default connect(mapStateToProps)(NoDataWrapper)
